module.exports = __webpack_public_path__ + "images/emoji/thumbsdown.5a9b5d4ca21a3d76963d.png";